import styled from 'styled-components'

const CompanyStyle = styled.div.attrs((props) => ({ className: props.className }))`
	.company-products {
		margin-bottom: 0;
	}

	.company-products,
	.company-projects {
		margin-top: calc(var(--pageFromHeaderMargin) + var(--sp2-5x));

		.catalog-view {
			.bottom {
				flex-wrap: wrap;
				margin-bottom: 0;

				.single-catalog {
					margin-bottom: var(--sp4x);

					&:nth-child(4n) {
						margin-left: var(--sp2x);
						margin-right: 0;
					}

					&:nth-child(4n-1) {
						margin-left: var(--sp2x);
						margin-right: var(--sp2x);
					}
					&:nth-child(4n-2) {
						margin-left: var(--sp2x);
						margin-right: var(--sp2x);
					}
					&:nth-child(4n-3) {
						margin-right: var(--sp2x);
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		.company-products,
		.company-projects {
			.catalog-view {
				.bottom {
					flex-wrap: wrap;

					.single-catalog {
						margin-bottom: var(--sp3x);
						width: calc(33.333% - var(--sp2x));

						&:nth-child(4n) {
							margin-left: unset;
							margin-right: unset;
						}

						&:nth-child(4n-1) {
							margin-left: unset;
							margin-right: unset;
						}
						&:nth-child(4n-2) {
							margin-left: unset;
							margin-right: unset;
						}
						&:nth-child(4n-3) {
							margin-right: unset;
						}

						&:nth-child(3n) {
							margin-left: var(--sp1-5x);
							margin-right: 0;
						}

						&:nth-child(3n-1) {
							margin-left: var(--sp1-5x);
							margin-right: var(--sp1-5x);
						}
						&:nth-child(3n-2) {
							margin-left: var(--sp1-5x);
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		.company-products,
		.company-projects {
			.catalog-view {
				.bottom {
					flex-wrap: wrap;

					.single-catalog {
						margin-bottom: var(--sp3x);
						width: calc(50% - var(--sp1-5x));

						&:nth-child(4n) {
							margin-left: unset;
							margin-right: unset;
						}

						&:nth-child(4n-1) {
							margin-left: unset;
							margin-right: unset;
						}
						&:nth-child(4n-2) {
							margin-left: unset;
							margin-right: unset;
						}

						&:nth-child(4n-3) {
							margin-right: unset;
						}

						&:nth-child(2n) {
							margin-left: var(--sp1-5x);
							margin-right: 0;
						}

						&:nth-child(2n-1) {
							margin-right: var(--sp1-5x);
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.company-products,
		.company-projects {
			.catalog-view {
				.bottom {
					flex-wrap: wrap;

					.single-catalog {
						margin-bottom: var(--sp2x);
						width: 100%;

						&:nth-child(4n) {
							margin-left: unset;
							margin-right: unset;
						}

						&:nth-child(4n-1) {
							margin-left: unset;
							margin-right: unset;
						}
						&:nth-child(4n-2) {
							margin-left: unset;
							margin-right: unset;
						}

						&:nth-child(4n-3) {
							margin-right: unset;
						}
					}
				}
			}
		}
	}
`
export default CompanyStyle
